import React from 'react';
import { offerConfig } from '../data/siteConfig';
import { CTABlock } from './Shared';
export const HeroSection = () => {
  return <header id="hero" className="relative overflow-hidden bg-familia-dark" data-id="element-113" data-mp="2hvm6kecsxwec">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-114" data-mp="23vtiyrwknwal" />

      {/* En mobile el CTA sube justo debajo de la imagen para quedar visible sin scrollear */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-5 md:pt-8 pb-12 text-center flex flex-col items-center" data-id="element-115" data-mp="2wjp91drmypye">
        <p className="order-1 text-familia-gold font-semibold text-[12px] sm:text-[13px] uppercase tracking-[0.18em] mb-2 md:mb-3 max-w-2xl leading-relaxed" data-id="element-116" data-mp="30ltzy4qp98hc">
          Vitalidad 360 · Kit imprimible para acompañar adultos mayores en casa
        </p>

        <h1 className="order-2 font-display text-white font-bold text-[30px] sm:text-4xl md:text-5xl leading-[1.15] mb-4 md:mb-5 max-w-4xl" data-id="element-117" data-mp="2rr604u3w8izx">
          Qué hacer hoy a la tarde con tu mamá o tu papá.{' '}
          <span className="text-familia-accent" data-id="element-118" data-mp="3kbe7lbv1wans">
            Ya pensado, ya ordenado, listo para imprimir.
          </span>
        </h1>

        <div className="order-3 relative w-[70%] sm:w-full sm:max-w-[460px] md:max-w-[560px] mb-4 md:mb-6" style={{
        aspectRatio: '3 / 2'
      }} data-id="element-119" data-mp="2begmg4hjaa19">
          <img src="https://cdn.magicpatterns.com/uploads/nQuCFAXjN5rWqH1CYg6bzM/ChatGPT_Image_28_may_2026__09_10_42_p.m.-removebg-preview.png" alt="Vitalidad 360 Master Kit — Kinesiólogo presentando el sistema" width="560" height="373" loading="eager" fetchPriority="high" decoding="async" className="relative z-10 w-full h-full object-contain md:drop-shadow-[0_12px_24px_rgba(0,0,0,0.45)]" data-id="element-120" data-mp="2p6msuyuvx2ni" />
        </div>

        <div className="order-5 md:order-4 max-w-2xl mt-6 md:mt-0" data-id="element-121" data-mp="3823bhhca2q4o">
          
          <p className="text-body font-bold text-white md:mb-7" data-id="element-122" data-mp="335mhi6iedhjo">
            Pagás y te llega al mail en minutos. Hoy mismo ya podés tener la
            primera actividad sobre la mesa.
          </p>
        </div>

        <CTABlock href="#precio-lanzamiento" tone="dark" className="order-4 md:order-5" buttonClassName="md:px-10" data-id="element-123" data-mp="18t6d7b95wdhg">
          QUIERO EL KIT — LO RECIBO YA
        </CTABlock>

        <div className="order-6 mt-5 flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-[14px] sm:text-[15px] text-familia-onDarkMuted" data-id="element-124" data-mp="3dsxy2utod5b1">
          <span data-id="element-125" data-mp="3msugwftdv9y6">🔒 Mercado Pago (tarjeta, débito o dinero en cuenta)</span>
          <span data-id="element-126" data-mp="3mqzwr3pxrlv5">🛡️ {offerConfig.guaranteeDays} días de garantía</span>
          <span data-id="element-127" data-mp="3rrnv6aghv4ze">⚡ Descarga inmediata</span>
        </div>
      </div>
    </header>;
};